<template>
  <div class="vc-panel">
    <TabView class="vtab" :menus="menus" :selectKey="selectKey" @menuClick="menuClick"></TabView>
    <component :is="selectKey" class="vtab-content vh-full"></component>
  </div>
</template>

<script>
import TabView from '@/components/TabView.vue'
import NewWordOverview from './NewWordOverview.vue';
import NewWordList from './NewWordList.vue';
export default {
  name: 'NewWordPage',
  components:{
    TabView,
    NewWordOverview,
    NewWordList
  },
  props: {
    
  },
  data(){
    return {
        menus:[
            //{name:"概览",key:"NewWordOverview"},
            {name:"词汇",key:"NewWordList"}
        ],
        selectKey:"NewWordList"
    }
  },
  methods:{
    ///菜单点击
    menuClick: function (item) {
        this.selectKey = item.key
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.vtab{
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 10px;
}
</style>
